import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ITermsPayload, IInitialStateTerms} from "../types";
import {GetTerms, GetDeleteTerms} from "./thunk";

const initialState:IInitialStateTerms = {
    termData:[],
    isLoadingTerm:false,
    termsRestore:[],
    isViewTermsRestore:false,
    selectedTermsIDs:[],
    filteredTerm:[]

}

const academicTermsSlice = createSlice({
    name:"academicTerms",
    initialState,
    reducers:{
     setTerms: (state, action: PayloadAction<{data:ITermsPayload[],defaultLanguage:string}>) => {
         const {data,defaultLanguage} = action.payload;
               state.termData = data
               state.filteredTerm = data.flatMap(
                   (data) =>
                       data.translations
                           .filter((elem) => elem.slug === defaultLanguage && elem.name)
                           .map((elem) => ({
                               id: data.id,
                               name: elem.name as string,
                           }))
               );


     },

        deletedTerm:(state,action: PayloadAction<number>) => {
            state.termData = state.termData.filter((elem)=>elem.id !== action.payload)

        },
        deletedRestoreTerms:(state,action)=>{
            state.termsRestore = state.termsRestore.filter(
                (elem) => elem.id !== action.payload
            );

        },
        updateTerm: (state, action: PayloadAction<ITermsPayload>) => {
            const updateData = action.payload;

            state.termData = state.termData.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData
                    };
                }
                return elem;
            });
        },

        setIsViewTermsRestore:(state)=>{

            state.isViewTermsRestore =!state.isViewTermsRestore;
        },
        setTermsRestore:(state, action) => {
            state.termsRestore = action.payload;
        },
        setSelectedTermIDs: (state, action) => {
            state.selectedTermsIDs=action.payload
        },

    },
    extraReducers:(builder)=>{
        builder.addCase(GetTerms.pending,state=>{
            state.isLoadingTerm = true
        })
            .addCase(GetTerms.fulfilled,(state)=>{
                state.isLoadingTerm = false
            })
            .addCase(GetTerms.rejected,state=>{
                state.isLoadingTerm = false
            })
            .addCase(GetDeleteTerms.pending,state=>{
                state.isLoadingTerm = true
            })
            .addCase(GetDeleteTerms.fulfilled,(state)=>{
                state.isLoadingTerm = false
            })
            .addCase(GetDeleteTerms.rejected,state=>{
                state.isLoadingTerm = false
            })
    }


})
export const {
    setTerms,
    setSelectedTermIDs,
    deletedTerm,
    updateTerm,
    setIsViewTermsRestore,
    setTermsRestore,
    deletedRestoreTerms
} = academicTermsSlice.actions;
export default academicTermsSlice